import axios from "axios";

const localBaseUrl = "https://drivenowbackend.onrender.com";

export const details = {
  base_url: localBaseUrl,
};

export const BASE_URL = localBaseUrl;

const instance = axios.create({
  baseURL: localBaseUrl,
  headers: {
    "Content-Type": "application/json",
  },
});

export default instance;
